export const AdminCarouselPanel = () => {
  return <div>AdminCarouselPanel</div>;
};
